let config;
//apiurl ==> api audience
switch(process.env.REACT_APP_STAGE) {
  case 'local':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'http://localhost:3000/callback',
    }
    break;
  case 'development':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'https://project-y.gogochart.com/callback',
    }
    break;
  case 'aliyun-dev':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'https://project-y.gogochart.com/callback',
    }
    break;
  case 'production':
    config = {
      domain: 'projectx.au.auth0.com',
      apiUrl: 'https://prdapi.gogochart.com/',
      clientId: 'P2NblPndrakfGq4UO1mQNYaWLIVep72B',
      callbackUrl: 'https://project-x.gogochart.com/callback',
    }
    break;
  case 'fake':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      //callbackUrl: 'http://project-y.gogochart.com/callback',
      callbackUrl: 'http://localhost:3000/callback',
    }
    break;
  case 'local-y':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'http://localhost:3000/callback',
    }
    break;
  case 'dev-zay':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'http://zay.gogochart.com/callback',
    }
    break;
  case 'dev-wesley':
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'http://wesley.gogochart.com/callback',
    }
    break;
  default:
    config = {
      domain: 'project-xx.au.auth0.com',
      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
      apiUrl: 'http://localhost/',
      callbackUrl: 'http://localhost:3000/callback',
    }
}
console.log( config)
export const AUTH_CONFIG = config;


// WEBPACK FOOTER //
// ./src/constants/auth0.js